import {useState} from "react";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {CalculatorInitialValuesType} from "../types/CalculatorInitialValuesType";
import {CalculatorValueType} from "../types/CalculatorValueType";

export interface ICalculatorState {
    updateValue: (type: CalculatorValueType, value: number) => void;
    age: number;
    price: number;
    contribution: number;
    period: number;
    earnings: number;
}

export interface IRatingCalculatorState {
    updateValue: (type: CalculatorValueType, value: number) => void;
    age: number;
    averageEarnings: number;
    loanInstallments: number;
    householdExpenses: number;
}

export const useCalculatorState = (initialValue: CalculatorInitialValuesType): ICalculatorState => {
    const [price, setPrice] = useState<number>(initialValue[CalculatorValueType.PRICE]);
    const [earnings, setEarnings] = useState<number>(initialValue[CalculatorValueType.EARNINGS]);
    const [contribution, setContribution] = useState<number>(initialValue[CalculatorValueType.CONTRIBUTION]);
    const [period, setPeriod] = useState<number>(initialValue[CalculatorValueType.PERIOD]);
    const [age, setAge] = useState<number>(initialValue[CalculatorValueType.AGE]);

    const updateValue = (type: CalculatorValueType, value: number) => {
        switch (type) {
            case CalculatorValueType.PRICE:
                setPrice(value);
                break;
            case CalculatorValueType.CONTRIBUTION:
                setContribution(value);
                break;
            case CalculatorValueType.PERIOD:
                setPeriod(value);
                break;
            case CalculatorValueType.AGE:
                setAge(value);
                break;
            case CalculatorValueType.EARNINGS:
                setEarnings(value);
                break;
            default:
                notifyBugsnag("error useCalculatorState", "modifyValue - type error");
        }
    };

    return {
        price,
        contribution,
        period,
        age,
        earnings,
        updateValue
    };
};

export const useCalculatorRatingState = (initialValue: CalculatorInitialValuesType): IRatingCalculatorState => {
    const [averageEarnings, setAverageEarnings] = useState<number>(initialValue[CalculatorValueType.AVERAGE_EARNINGS]);
    const [householdExpenses, setHouseholdExpenses] = useState<number>(initialValue[CalculatorValueType.HOUSEHOLD_EXPENSES]);
    const [loanInstallments, setLoanInstallments] = useState<number>(initialValue[CalculatorValueType.LOAN_INSTALLMENTS]);
    const [age, setAge] = useState<number>(initialValue[CalculatorValueType.AGE]);

    const updateValue = (type: CalculatorValueType, value: number) => {
        switch (type) {
            case CalculatorValueType.AVERAGE_EARNINGS:
                setAverageEarnings(value);
                break;
            case CalculatorValueType.HOUSEHOLD_EXPENSES:
                setHouseholdExpenses(value);
                break;
            case CalculatorValueType.LOAN_INSTALLMENTS:
                setLoanInstallments(value);
                break;
            case CalculatorValueType.AGE:
                setAge(value);
                break;
            default:
                console.error("modifyValue - type error");
        }
    };

    return {
        averageEarnings,
        householdExpenses,
        loanInstallments,
        age,
        updateValue
    };
};
import {useState} from "react";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {CalculatorInitialValuesType} from "../types/CalculatorInitialValuesType";
import {CalculatorValueType} from "../types/CalculatorValueType";

export interface ICalculatorState {
    updateValue: (type: CalculatorValueType, value: number) => void;
    age: number;
    price: number;
    contribution: number;
    period: number;
    earnings: number;
}

export interface IRatingCalculatorState {
    updateValue: (type: CalculatorValueType, value: number) => void;
    age: number;
    averageEarnings: number;
    loanInstallments: number;
    householdExpenses: number;
}

export const useCalculatorState = (initialValue: CalculatorInitialValuesType): ICalculatorState => {
    const [price, setPrice] = useState<number>(initialValue[CalculatorValueType.PRICE]);
    const [earnings, setEarnings] = useState<number>(initialValue[CalculatorValueType.EARNINGS]);
    const [contribution, setContribution] = useState<number>(initialValue[CalculatorValueType.CONTRIBUTION]);
    const [period, setPeriod] = useState<number>(initialValue[CalculatorValueType.PERIOD]);
    const [age, setAge] = useState<number>(initialValue[CalculatorValueType.AGE]);

    const updateValue = (type: CalculatorValueType, value: number) => {
        switch (type) {
            case CalculatorValueType.PRICE:
                setPrice(value);
                break;
            case CalculatorValueType.CONTRIBUTION:
                setContribution(value);
                break;
            case CalculatorValueType.PERIOD:
                setPeriod(value);
                break;
            case CalculatorValueType.AGE:
                setAge(value);
                break;
            case CalculatorValueType.EARNINGS:
                setEarnings(value);
                break;
            default:
                notifyBugsnag("error useCalculatorState", "modifyValue - type error");
        }
    };

    return {
        price,
        contribution,
        period,
        age,
        earnings,
        updateValue
    };
};

export const useCalculatorRatingState = (initialValue: CalculatorInitialValuesType): IRatingCalculatorState => {
    const [averageEarnings, setAverageEarnings] = useState<number>(initialValue[CalculatorValueType.AVERAGE_EARNINGS]);
    const [householdExpenses, setHouseholdExpenses] = useState<number>(initialValue[CalculatorValueType.HOUSEHOLD_EXPENSES]);
    const [loanInstallments, setLoanInstallments] = useState<number>(initialValue[CalculatorValueType.LOAN_INSTALLMENTS]);
    const [age, setAge] = useState<number>(initialValue[CalculatorValueType.AGE]);

    const updateValue = (type: CalculatorValueType, value: number) => {
        switch (type) {
            case CalculatorValueType.AVERAGE_EARNINGS:
                setAverageEarnings(value);
                break;
            case CalculatorValueType.HOUSEHOLD_EXPENSES:
                setHouseholdExpenses(value);
                break;
            case CalculatorValueType.LOAN_INSTALLMENTS:
                setLoanInstallments(value);
                break;
            case CalculatorValueType.AGE:
                setAge(value);
                break;
            default:
                console.error("modifyValue - type error");
        }
    };

    return {
        averageEarnings,
        householdExpenses,
        loanInstallments,
        age,
        updateValue
    };
};
